import { useAuthStore } from "../../stores/auth";
import { TwinResponse } from "@shared/services/twinManagement";
import { clientId, roles } from "../constants";

export type TicketManagementAuth = {
  isTicketTypeManager: (ticket: TwinResponse) => boolean;
  isTicketTypeProcessor: (ticket: TwinResponse) => boolean;
  isPlanner: (ticket: TwinResponse) => boolean;
  isAdmin: () => boolean;
  isTicketCreator: () => boolean;
  isUser: () => boolean;
};

export function useAssetTicketManagementAuth(): TicketManagementAuth {
  const authStore = useAuthStore();

  // TODO: backend currently does not support groups, for now we just check for admin role

  function isTicketTypeProcessor(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      false
    );
  }

  function isTicketTypeManager(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      false
    );
  }

  function isPlanner(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.planner) ||
      false
    );
  }

  function isAdmin() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      false
    );
  }

  function isTicketCreator() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(
        roles.ticketCreator,
      ) || false
    );
  }

  function isUser() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.user) || false
    );
  }

  return {
    isTicketTypeManager,
    isTicketTypeProcessor,
    isPlanner,
    isAdmin,
    isTicketCreator,
    isUser,
  };
}
